module.exports = __webpack_public_path__ + "img/aboutus.04bce713.svg";